module.exports = __webpack_public_path__ + "img/Bot Stopper 3.23c50060.png";